import type { WalletName } from '@solana/wallet-adapter-base';
import { getCwySolanaWalletAdapters } from '../providers/solanaAdapters';

declare global {
  interface Window {
    backpack?: {
      isBackpack?: boolean;
      isConnected?: boolean;
      disconnect?: () => Promise<void>;
    };
  }
}

const BACKPACK_ADAPTER_NAME = 'Backpack' as WalletName<'Backpack'>;

/** Drop other extension sessions so Backpack cannot hijack a non-Backpack connect. */
export async function prepareWalletConnection(targetAdapterName: WalletName): Promise<void> {
  const adapters = getCwySolanaWalletAdapters();

  await Promise.all(
    adapters.map(async (adapter) => {
      if (adapter.name === targetAdapterName || !adapter.connected) return;
      try {
        await adapter.disconnect();
      } catch {
        // ignore stale extension state
      }
    })
  );

  if (targetAdapterName === BACKPACK_ADAPTER_NAME || typeof window === 'undefined') {
    return;
  }

  const backpack = window.backpack;
  if (!backpack?.isConnected || typeof backpack.disconnect !== 'function') {
    return;
  }

  try {
    await backpack.disconnect();
  } catch {
    // ignore
  }
}
